import {Text, Heading, SimpleGrid, Button} from '@chakra-ui/react';
import React, {useEffect, useState} from 'react';
import {CustomCheckbox} from '../General/FormInputs';
import {formatDate} from '../../helpers/Functions';
import {get} from '../../service/ApiService';
import BoxCard from '../General/BoxCard';
import {Arranger} from '../../service/Urls';
import {Satisfaction} from '../../constants/Satisfaction';

const MaintenanceHeader = ({includeCovid, control, masterData, data, noDeceased, isPet, setData, reset, ids, getValues, submit}) => {
  const [arrangerName, setArrangerName] = useState('');
  useEffect(() => {
    loadData();
  }, []);

  const setSatisfaction = satisfactionLevel => {
    const newData = getValues();
    ids.forEach(id => {
      newData[id] = satisfactionLevel;
    });
    setData(newData);
    reset(newData);
  };

  const setComment = suffix => {
    const newData = getValues();
    newData['svComment'] += suffix;
    setData(newData);
    reset(newData);
  };

  const loadData = async () => {
    const arranger = await get(Arranger.GET_BY_CODE + '?ArrangerCode=' + masterData.smArrid);
    setArrangerName(arranger.arName);
  };

  useEffect(() => {
    const onCommentHotkey = e => {
      if (e.altKey) {
        switch (e.key) {
          case '1':
            setComment('\n\nRe. #  ). Client commented: ');
            break;
          case '2':
            setComment('\nStaff member(s) who were particularly helpful: ');
            break;
          case '3':
            setComment('\n\nAt the top of the survey, client commented: ');
            break;
          default:
            break;
        }
      }
    };

    document.addEventListener('keydown', onCommentHotkey);

    return () => {
      document.removeEventListener('keydown', onCommentHotkey);
    };
  }, [setComment]);

  useEffect(() => {
    const onSatisfactionHotkey = e => {
      if (e.ctrlKey) {
        switch (e.key) {
          case 's':
            submit();
            e.preventDefault();
            break;
          case 'e':
            e.preventDefault();
            setSatisfaction(Satisfaction.EXCELLENT);
            break;
          case 'g':
            e.preventDefault();
            setSatisfaction(Satisfaction.GOOD);
            break;
          case 'f':
            e.preventDefault();
            setSatisfaction(Satisfaction.FAIR);
            break;
          case 'p':
            e.preventDefault();
            setSatisfaction(Satisfaction.POOR);
            break;
          case 'k':
            e.preventDefault();
            setSatisfaction(Satisfaction.NA);
          default:
            break;
        }
      }
    };

    document.addEventListener('keydown', onSatisfactionHotkey);

    return () => {
      document.removeEventListener('keydown', onSatisfactionHotkey);
    };
  }, [setSatisfaction]);

  return (
    <BoxCard>
      <SimpleGrid columns={6}>
        <Heading size="sm">Record No. </Heading>
        <Text>{masterData.smRecord}</Text>
        <Heading size="sm">Buyer Name</Heading>
        <Text>{masterData.smBfname + ' ' + masterData.smBlname}</Text>
        {!noDeceased && (
          <>
            <Heading size="sm">{isPet ? 'Pet Name' : 'Deceased Name'} </Heading>
            <Text size="sm">{isPet ? masterData.smPetname + ' ' + masterData.smPettype : masterData.smDfname + ' ' + masterData.smDlname}</Text>
          </>
        )}
        <Heading size="sm">Client No. </Heading>
        <Text size="sm">{masterData.smClient}</Text>
        <Heading size="sm">Client Name</Heading>
        <Text size="sm">{masterData.clientName}</Text>
        <Heading size="sm">Arranger</Heading>
        <Text size="sm">{arrangerName}</Text>
      </SimpleGrid>

      <SimpleGrid columns={6}>
        <Heading size="sm">Survey Received: </Heading>
        <Text size="sm">{formatDate(data.dateAdded)}</Text>
        <Heading size="sm">Contract No.</Heading>
        <Text size="sm">{masterData.smServid}</Text>
        <Heading size="sm">Contract Date</Heading>
        <Text size="sm">{masterData.contractDate}</Text>
      </SimpleGrid>
      {includeCovid && <CustomCheckbox name="COVID 19" id="svCovid" control={control} defaultChecked={data.svCovid} />}

      <SimpleGrid columns={8} mt="3" p={2} alignItems="center" borderRadius={5} backgroundColor="secondary.500">
        <Heading size="lg" color="white">
          Hotkeys
        </Heading>
        <Heading size="sm" color="white">
          Save: ctrl + s
        </Heading>
        <Heading size="sm" color="white">
          Excellent: ctrl + e
        </Heading>
        <Heading size="sm" color="white">
          Good: ctrl + g
        </Heading>
        <Heading size="sm" color="white">
          Fair: ctrl + f
        </Heading>
        <Heading size="sm" color="white">
          Poor: ctrl + p
        </Heading>
        <Heading size="sm" color="white">
          N/A: ctrl + k
        </Heading>
        <Heading size="sm" color="white">
          Comment: alt + 1, 2, 3
        </Heading>
      </SimpleGrid>
    </BoxCard>
  );
};

export default MaintenanceHeader;
